export interface SignGridComponentReducerStateInterface {
  [key: string]: any;
}

const SignGridComponentReducerState: SignGridComponentReducerStateInterface = {
  documentData: [],
  rowId: null,
  fileSigned: null,
  statusHistory: [],
  isPDFModalOpen: false,
  isSignModalOpen: false,
  isHistoryModalOpen: false,
};

export interface Action {
  type: string;
  payload: any;
}

export function SignGridComponentReducer(
  state: SignGridComponentReducerStateInterface = SignGridComponentReducerState,
  action: Action,
) {
  switch (action.type) {
    case 'GET_DOCUMENT_DATA': {
      return {
        ...state,
        documentData: [
          ...action.payload.map((item) => {
            return {
              files: item.files,
              id: item.id,
              signatureType: item.signature_type,
              status: item.status,
              memberId: item.team_member_id,
              documentType: item.type,
            };
          }),
        ],
      };
    }

    case 'SET_FILE_SIGNED': {
      return {
        ...state,
        fileSigned: action.payload,
      };
    }

    case 'DELETE_FILE_SIGNED': {
      return {
        ...state,
        fileSigned: undefined,
      };
    }

    case 'SET_ROW_ID': {
      return {
        ...state,
        rowId: action.payload,
      };
    }

    case 'GET_STATUS_HISTORY': {
      return {
        ...state,
        statusHistory: action.payload,
      };
    }

    case 'TOGGLE_PDF_MODAL': {
      return {
        ...state,
        isPDFModalOpen: action.payload,
      };
    }

    case 'TOGGLE_SIGN_MODAL': {
      return {
        ...state,
        isSignModalOpen: action.payload,
      };
    }

    case 'TOGGLE_HISTORY_MODAL': {
      return {
        ...state,
        isHistoryModalOpen: action.payload,
      };
    }

    default:
      return state;
  }
}
